<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNumOpportunitiesToGeneratePurchase',
    extends: TableRowBase,
    computed: {
      benchmarkDiffRaw() {
        return this.actualYtdRaw - this.benchmark.median_value_monthly;
      },
      benchmarkDiff() {
        // If not dealing with percentages
        if (this.type !== 'percent') {
          return this.round(Number.parseFloat(this.benchmarkDiffRaw), this.precision);
        }
        return this.benchmarkDiffRaw;
      },
      benchmarkDiffDisplay() {
        return this.getValueDiff(this.benchmarkDiff, this.benchmark.median_value_monthly);
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_ha_appointments', throughMonth),
          this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
        );
      },
    },
  };
</script>
